import React from "react";
import "./StarBackground.css";

const StarBackground = () => {
  return (
    <div className="star-background">
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
    </div>
  );
};

export default StarBackground;